import type { FC, SVGProps } from "react";

const ClockIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		{...props}
	>
		<circle cx="8" cy="8" r="6" stroke="#737180" strokeWidth="1.5" />
		<path
			d="M8 5v3.5l2.5 1.5"
			stroke="#737180"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export { ClockIcon };
